module.exports = __webpack_public_path__ + "static/media/burnt-cheesecake.b289bc6a.jpeg";